export const CATEGORIES = {
    TextCorrectness: {
        description: 'Rules for grammar, punctuation, and spelling',
    },
    TextFormatting: {
        description: 'Guidelines for capitalization, spacing, and typography',
    },
    ContentStyle: {
        description: 'Guidelines for writing style, messaging, and communication tone',
    },
    BrandAssets: {
        description: 'Guidelines for logo usage and visual brand elements',
    },
    TechnicalRequirements: {
        description: "Guidelines for assets' technical requirements, such as resolution, file format etc.",
    },
};
export const categoryNames = Object.keys(CATEGORIES);
/** How a category is written in an imported text file: `BrandAssets` is "Brand Assets". */
export const categoryImportName = (category) => category.replace(/([a-z])([A-Z])/g, '$1 $2');
